import { useContext } from 'react'
import { useMount } from 'react-use'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { ExtendedFormikContext } from './ExtendedFormik'

const FormikAutoSubmit = ({ conditionOnMount, submitForm }) => {
    const { setTouchedAll } = useContext(ExtendedFormikContext)

    useMount(() => {
        const submit = async () => {
            await setTouchedAll()
            submitForm()
        }

        if (conditionOnMount) {
            conditionOnMount() && submit()
        } else {
            submit()
        }
    })

    return null
}

FormikAutoSubmit.propTypes = {
    submitForm: PropTypes.func.isRequired,
    conditionOnMount: PropTypes.func,
}

export default flowRight(
    withErrorBoundaryNoRender,
)(FormikAutoSubmit)
